package com.myrestaurants.sharedmodels

import kotlinx.serialization.Serializable

@Serializable
data class UserCredentials(val recordId : String = "", val email: String, val password: String,
                           val deviceId : String, val app : String, val active : Boolean = false,
                           val googleId : String = "", val activateCode : String = "", val resetCode : String = "")